export const scrollToSection = (sectionId: string) => {
  console.log('Attempting to scroll to section:', sectionId);
  const element = document.getElementById(sectionId);
  console.log('Found element:', element);
  
  if (element) {
    console.log('Scrolling to element...');
    const headerHeight = 80; // Approximate header height
    const elementPosition = element.offsetTop - headerHeight;
    
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  } else {
    console.error('Element not found with ID:', sectionId);
  }
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
